import type { CalculatorMeta } from '../../types/calculator';

const meta: CalculatorMeta = {
  route: '/safe-withdrawal-rate-calculator',
  component: () => import('../../routes/SafeWithdrawal.svelte'),
  card: {
    id: 'safe-withdrawal-rate',
    title: 'Safe Withdrawal Rate',
    description: 'Find the sustainable withdrawal rate for retirement using Monte Carlo simulation.',
    icon: 'savings',
    iconBgClass: 'bg-emerald-50',
    iconTextClass: 'text-emerald-600',
    href: '/safe-withdrawal-rate-calculator',
    category: 'Retirement & Tax',
  },
  seo: {
    title: 'Safe Withdrawal Rate Calculator – Retirement Sustainability',
    description: 'Find if your retirement portfolio can sustain your withdrawals over time. Uses Monte Carlo simulation based on historical stock/bond returns to estimate the probability your savings last 30+ years.',
  },
};

export default meta;
